import Network from './Network';
// import { useContext } from 'react';
// import AuthContext from '../contexts/AuthContext'

//const ec2 = 'https://shop.wizmon.co.kr/apis/';
//const local = 'http://localhost:3000/apis/';
//const dev = 'https://dev.wizmon.co.kr/apis/';

const apiUrl = process.env.REACT_APP_API_URL;
console.log('apiUrl: ', apiUrl);

// const { auth: tokenForInicis } = useContext(AuthContext);

/* attach */
export const getAttachDetail = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.request(
    '/apis/attach/getAttachDetail',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData(response.data.attach);
    setIsReady(true);
  }
};

export const getAttachList = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  setCount
) => {
  const response = await Network.request(
    '/apis/attach/getAttachList',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData(response.data.attachList);
    if (setCount != null) setCount(response.data.rows);
    setIsReady(true);
  }
};

export const addAttach = async (reqParam, setData, setIsReady, handleError) => {
  const response = await Network.request(
    '/apis/attach/addAttach',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

export const updateAttach = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.request(
    '/apis/attach/updateAttach',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

export const deleteAttach = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.request(
    '/apis/attach/deleteAttach',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

/* auth */
export const signUp = async (reqParam, setData, setIsReady, handleError) => {
  const response = await Network.request(
    '/apis/auth/signUp',
    reqParam,
    handleError
  );
  if (response !== null) {
    console.log(response);
    setData();
    setIsReady(true);
  }
};

export const signIn = async (reqParam, setData, setIsReady, handleError) => {
  const response = await Network.request(
    '/apis/auth/signIn',
    reqParam,
    handleError
  );
  if (response !== null) {
    // console.log(response);
    setData(response.data);
    setIsReady(true);
  }
};

export const checkEmailDuplication = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.request(
    '/apis/auth/checkEmailDuplication',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData(response.data.success);
    console.log(response.data.success);
    setIsReady(true);
  }
};

export const checkIdDuplication = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.request(
    '/apis/auth/checkIdDuplication',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData(response.data.success);
    console.log('nf', response.data.success);
    setIsReady(true);
  }
};

export const sendResetEmail = async (reqParam, setData, handleError) => {
  const response = await Network.request(
    '/apis/auth/sendResetMail',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData(response.data.hash);
  }
};

export const resetPassword = async (reqParam, setData, handleError) => {
  const response = await Network.request(
    '/apis/auth/resetPassword',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData(response.data.hash);
  }
};

/* contents */

export const getContentsDetail = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/contents/getContentsDetail',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data.contents);
    setIsReady(true);
    console.log('getContentsDetail', response);
  }
};

export const getContentsDetailFromEC2 = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    apiUrl + '/apis/contents/getContentsDetail',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data.contents);
    setIsReady(true);
  }
};

export const getContentsList = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/contents/getContentsList',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data.contentsList);
    // if(setCount != null) setCount(response.data.rows);
    setIsReady(true);
  }
};

export const getContentsListWithoutYn = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/contents/getContentsListWithoutYn',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data.contentsList);
    // if(setCount != null) setCount(response.data.rows);
    setIsReady(true);
  }
};

export const addContents = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/contents/addContents',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData();
    setIsReady(true);
    return response;
  }
};

export const updateContents = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/contents/updateContents',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

export const deleteContents = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/contents/deleteContents',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

/* etcs */
export const getTelecomList = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  setCount
) => {
  const response = await Network.request(
    '/apis/etcs/getTelecomList',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData(response.data.telecomList);
    if (setCount != null) setCount(response.rows);
    setIsReady(true);
  }
};

export const getIndustryList = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  setCount
) => {
  const response = await Network.request(
    '/apis/etcs/getIndustryList',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData(response.data.industryList);
    if (setCount != null) setCount(response.data.rows);
    setIsReady(true);
  }
};

export const getYoutubeAPIKey = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.request(
    '/apis/etcs/getYoutubeAPIKey',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData(response.data.contentsList); // ! example response 없어서 모르겠음.
    setIsReady(true);
  }
};

// 업로드 이미지 !!
export const uploadImage = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.request(
    '/apis/etcs/uploadImage',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

/* item */
export const getItemDetail = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.request(
    '/apis/item/getItemDetail',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData(response.data.item);
    setIsReady(true);
  }
};

export const getItemList = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  setCount,
  token
) => {
  const response = await Network.request(
    '/apis/item/getItemList',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data.itemList);
    if (setCount != null) setCount(response.data.rows);
    setIsReady(true);
  }
};

export const addItem = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/item/addItem',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

export const updateItem = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.request(
    '/apis/item/updateItem',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

export const deleteItem = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.request(
    '/apis/item/deleteItem',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

/* notice */
export const getNoticeDetail = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/notice/getNoticeDetail',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data.notice);
    setIsReady(true);
  }
};

export const getNoticeList = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/notice/getNoticeList',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data.noticeList);
    // if(setCount != null) setCount(response.data.rows);
    setIsReady(true);
  }
};

export const addNotice = async (reqParam, setData, setIsReady, handleError) => {
  const response = await Network.request(
    '/apis/notice/addNotice',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

export const updateNotice = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.request(
    '/apis/notice/updateNotice',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

export const deleteNotice = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.request(
    '/apis/notice/deleteNotice',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

export const getNoticePrevNext = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/notice/getNoticePrevNext',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

/* payment */
export const getPaymentDetail = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/payment/getPaymentDetail',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data.payment);
    setIsReady(true);
  }
};

export const getPaymentList = async (reqParam, setData, handleError, token) => {
  const response = await Network.request(
    '/apis/payment/getPaymentList',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
  }
};

export const addPayment = async (reqParam, setIsReady, handleError, token) => {
  const response = await Network.request(
    '/apis/payment/addPayment',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setIsReady(true);
  }
};

export const updatePayment = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/payment/updatePayment',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

export const deletePayment = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/payment/deletePayment',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

/* payment - inicis */
export const addInicisPayment = async (
  reqParam,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/payment/addInicisPayment',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setIsReady(true);
  }
};

export const getInicisPayment = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/payment/getInicisPayment',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

export const getInicisPaymentList = async (
  reqParam,
  setData,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/payment/getInicisPaymentList',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
  }
};

export const updateInicisPayment = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/payment/updateInicisPayment',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

export const deleteInicisPayment = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/payment/deleteInicisPayment',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

export const cancelInicisPayment = async (
  reqParam,
  setData,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/payment/cancelInicisPayment',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    console.log('cancelInicisPayment response: ', response);
    setData(response.data);
  }
};

/* plan */
export const getPlanDetail = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.request(
    '/apis/plan/getPlanDetail',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData(response.data.plan);
    setIsReady(true);
  }
};

export const getPlanList = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  setCount
) => {
  const response = await Network.request(
    '/apis/plan/getPlanList',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData(response.data.planList);
    if (setCount != null) setCount(response.data.rows);
    setIsReady(true);
  }
};

export const addPlan = async (reqParam, setData, setIsReady, handleError) => {
  const response = await Network.request(
    '/apis/plan/addPlan',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

export const updatePlan = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.request(
    '/apis/plan/updatePlan',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

export const deletePlan = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.request(
    '/apis/plan/deletePlan',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

/* slide */
export const getSlideDetail = async (
  reqParam,
  token,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.request(
    '/apis/slide/getSlideDetail',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(); // ! response.data.plan일거같은뎅?
    setIsReady(true);
  }
};

export const getSlideList = async (reqParam, handleError, token) => {
  const response = await Network.request(
    '/apis/slide/getSlideList',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    // setData(response.data.slideList);
    // if(setCount != null) setCount(response.data.rows);
    // setIsReady(true);
    return response;
  }
};

export const getSlideListFromEC2 = async (
  reqParam,
  token,
  setData,
  setIsReady,
  handleError,
  setCount
) => {
  const response = await Network.request(
    apiUrl + '/apis/slide/getSlideList',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    // setData(response.data.slideList);
    // if(setCount != null) setCount(response.data.rows);
    // setIsReady(true);
    return response;
  }
};

export const addSlide = async (reqParam, handleError, token) => {
  const response = await Network.request(
    '/apis/slide/addSlide',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    return response;
  }
};

export const updateSlide = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/slide/updateSlide',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

export const deleteSlide = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/slide/deleteSlide',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

/* user */
export const getUserDetail = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/user/getUserDetail',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

export const getUserList = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  setCount
) => {
  const response = await Network.request(
    '/apis/user/getUserList',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData(response.data.userList);
    if (setCount != null) setCount(response.data.rows);
    setIsReady(true);
  }
};

export const updateUser = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/user/updateUser',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

export const deleteUser = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.request(
    '/apis/user/deleteUser',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

export const getLinkedShop = async (reqParam, setData, handleError, token) => {
  const response = await Network.request(
    '/apis/user/getLinkedShop',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data.linkedShop);
  }
};

export const checkPlugins = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/user/checkPlugins',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    console.log(response);
    setData(response);
    setIsReady(true);
  }
};

export const authCode = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/v2/oauth/authorize?response_type=code&client_id=Ckrcls9bBNduyVy2vFfpnC&state=asdf&redirect_uri=https://shop.wizmon.co.kr/cafe24/apitest/&scope=mall.read_product,mall.write_product,mall.read_store,mall.write_application,mall.read_application,mall.read_design,mall.read_community,mall.write_community,mall.read_category,mall.write_category',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData();
    setIsReady(true);
  }
};

export const getTopTenItemInfo = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/statistics/getTopTenItemInfo',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

export const getTodayTopThreeItemInfo = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/statistics/getTodayTopThreeItemInfo',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

export const getPurchaseInductionRateByContents = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/statistics/getPurchaseInductionRateByContents',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

export const getTodayContentsInfo = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/statistics/getTodayContentsInfo',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

// 콘텐츠 조회 - 분석리포트 (재생구간)
export const getContentsPlayRange = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/statistics/getContentsPlayRange',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

// 콘텐츠 인기상품
export const getContentsStatisticsByTime = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/statistics/getContentsStatisticsByTime',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

// 시간대 별 상품 순위
export const getItemStatisticsByTime = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/statistics/getItemStatisticsByTime',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

export const insertContentsTimeLog = async (reqParam) => {
  const response = await Network.cafe24Request(
    apiUrl + '/apis/insertContentsTimeLog' + reqParam
  );
};

export const insertContentsViewLog = async (reqParam) => {
  const response = await Network.cafe24Request(
    apiUrl + '/apis/insertContentsViewLog' + reqParam
  );
};

export const insertItemLog = async (reqParam) => {
  const response = await Network.cafe24Request(
    apiUrl + '/apis/insertItemLog' + reqParam
  );
};

export const insertMakeShopItemLog = async (reqParam) => {
  const response = await Network.cafe24Request(
    apiUrl + '/apis/insertMakeShopItemLog' + reqParam
  );
};

export const insertSlideLog = async (reqParam) => {
  const response = await Network.cafe24Request(
    apiUrl + '/apis/insertSlideLog' + reqParam
  );
};

export const getContentsDetailParams = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.cafe24Request(
    apiUrl + '/apis/getContentDetail/',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

export const getSlideListParams = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  setCount
) => {
  const response = await Network.cafe24Request(
    apiUrl + '/apis/getSlideList/',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

export const getUserDetailParams = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  setCount
) => {
  const response = await Network.cafe24Request(
    apiUrl + '/apis/getUserDetail/',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

// cafe24 인증 코드로 access token 발급
export const getShopToken = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/cafe24/getShopToken',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
    // setIsReady(true)
  }
};

export const getShopTokenByRefreshToken = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/cafe24/getShopTokenByRefreshToken',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
    // setIsReady(true)
  }
};

export const getShopSkin = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/cafe24/getShopSkin',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
    // setIsReady(true)
  }
};

export const getMobileShopSkin = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/cafe24/getMobileShopSkin',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
  }
};

export const setShopScript = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/cafe24/setShopScript',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
  }
};
export const setMobileShopScript = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/cafe24/setMobileShopScript',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
  }
};
export const getShopProduct = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/cafe24/getShopProduct',
    reqParam,
    handleError,
    token
  );

  if (response !== null) {
    setData(response.data);
    // setIsReady(true)
  }
};

export const getShopProductCount = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/cafe24/getShopProductCount',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
    // setIsReady(true)
  }
};

export const deleteShopScript = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/cafe24/deleteShopScript',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
  }
};

export const deleteMobileShopScript = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/cafe24/deleteMobileShopScript',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
  }
};

/**
 * makeshop 상품 가져오기
 * @param { Object } reqParam - {shopDomain, shopKey}
 */
export const getMakeShopProductList = async (
  reqParam,
  setData,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/makeshop/getMakeShopProductList',
    reqParam,
    handleError,
    token
  );

  if (response !== null) {
    setData(response.data);
  }
};

// 게시된 콘텐츠
export const getPublishedContentsList = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/published/getPublishedContentsList',
    reqParam,
    handleError,
    token
  );
  console.log(response);
  if (response !== null) {
    setData(response.data.contentsList);
    setIsReady(true);
  }
};

export const getPublishedContentByNo = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/published/getPublishedContentByNo',
    reqParam,
    handleError,
    token
  );
  console.log(response);
  if (response !== null) {
    setData(response.data.publishedContent);
    setIsReady(true);
  }
};

export const addPublishedContents = async (
  reqParam,
  setData,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/published/addPublishedContents',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data.hash);
  }
};

export const updatePublishedContents = async (
  reqParam,
  setData,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/published/updatePublishedContents',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    console.log(response.data);
    setData(response.data.updatedContents);
  }
};

export const deletePublishedContents = async (
  reqParam,
  setData,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/published/deletePublishedContents',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData();
    return response;
  }
};

export const getPCPublishedContentList = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/published/getPCPublishedContentList',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

export const getMobilePublishedContentList = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/published/getMobilePublishedContentList',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

export const getPublishedContentsByShop = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/published/getPublishedContentsByShop',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};
export const getPublishedContentsWithOptions = async (
  reqParam,
  setData,
  setIsReady,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/published/getPublishedContentsWithOptions',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

export const getPublishedContentByShopURL = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.cafe24Request(
    apiUrl + '/apis/getPublishedContentByShopURL',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

export const getPublishedContentByHash = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.cafe24Request(
    apiUrl + '/apis/published/getPublishedContentByHash',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

export const getMobilePublishedContentByShopURL = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.cafe24Request(
    apiUrl + '/apis/getMobilePublishedContentByShopURL',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

export const getMobilePublishedContentByHash = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.cafe24Request(
    apiUrl + '/apis/published/getMobilePublishedContentByHash',
    reqParam,
    handleError
  );
  if (response !== null) {
    setData(response.data);
    setIsReady(true);
  }
};

export const getShopList = async (reqParam, setData, handleError, token) => {
  const response = await Network.request(
    '/apis/cafe24/getShopList',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
  }
};

export const getMobileShopEnabled = async (
  reqParam,
  setData,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/cafe24/getMobileShopEnabled',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
  }
};

export const getCafe24Payments = async (
  reqParam,
  setData,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/cafe24/getCafe24Payments',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
  }
};

export const addWizmonPayment = async (
  reqParam,
  setData,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/cafe24/addWizmonPayment',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
  }
};

export const getMobilePublishedContent = async (
  reqParam,
  setData,
  setIsReady,
  handleError
) => {
  const response = await Network.cafe24Request(
    apiUrl + '/apis/getMobilePublishedContent/',
    reqParam,
    handleError
  );
  if (response !== null) {
    console.log(response.data);
    setData(response.data);
    setIsReady(true);
  }
};

export const isPublished = async (reqParam, handleError, token) => {
  const response = await Network.request(
    '/apis/published/isPublished',
    reqParam,
    handleError,
    token
  );
  //console.log(reqParam, response)
  if (response !== null) {
    return response.data.isPublished;
  }
};

/* 모빌리언스 결제 */
export const addMobiliansPayment = async (
  reqParam,
  setData,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/payment/addMobiliansPayment',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
  }
};

export const cancelMobiliansPayment = async (
  reqParam,
  setData,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/payment/cancelMobiliansPayment',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
  }
};

/* KG이니시스 결제 */
export const addKGInicisPayment = async (
  reqParam,
  setData,
  handleError,
  token
) => {
  const response = await Network.request(
    '/apis/payment/addKGInicisPayment',
    reqParam,
    handleError,
    token
  );
  if (response !== null) {
    setData(response.data);
  }
};

export const getKGInicisPaymentCallback = async (handleError) => {
  const response = await Network.KGInicisPaymentRequest(
    '/apis/payment/callback',
    handleError
  );
  if (response !== null) {
    console.log(response);
  }
};
